import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FL120)
// ============================================================

export interface FL120 {
  fl120_01: string;        // 文件編號 (part of PK)
  fl120_02: number;        // 章節序號 (part of PK)
  fl120_11: string;        // 章節名稱
  fl120_12: string;        // 隸屬文件代號
  fl120_13: string | null; // 建檔日期
  fl120_14: string | null; // 備用日期
  fl120_17: number;        // 附件類型 (1=無,2=DOC,3=XLS,4=PPT,5=HTM,6=PDF)
  fl120_21: string;        // 章節內容 (MEMO)
  fl120_91: string;        // 建立人員
  fl120_92: string | null; // 修改日期
  fl120_93: string;        // 修改人員
}

/** Extended response with FL020 reference data (read-only, from GetByID) */
export interface FL120WithRefs extends FL120 {
  fl020_10: string;   // 部門代碼 (from FL020)
  fl020_16: string;   // 類別 (from FL020)
  tfl120_01: string;  // 章節編號 display (= FL120_01)
}

export interface CreateRequest {
  fl120_01: string; // 文件編號
  fl120_11: string; // 章節名稱
  fl120_12: string; // 隸屬文件代號
  fl120_17: number; // 附件類型
  fl120_21: string; // 章節內容 (MEMO)
}

export interface UpdateRequest {
  fl120_11: string; // 章節名稱
  fl120_12: string; // 隸屬文件代號
  fl120_17: number; // 附件類型
  fl120_21: string; // 章節內容 (MEMO)
}

export interface ListResponse {
  data: FL120[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const l202Api = {
  async list(page = 1, size = 100, keyword?: string, doc?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    if (doc) params.doc = doc;
    const res = await apiClient.get('/api/l202', { params });
    return res.data;
  },

  async get(docCode: string, seqNo: number): Promise<FL120WithRefs> {
    const res = await apiClient.get(`/api/l202/${encodeURIComponent(docCode)}/${seqNo}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FL120> {
    const res = await apiClient.post('/api/l202', data);
    return res.data;
  },

  async update(docCode: string, seqNo: number, data: UpdateRequest): Promise<FL120> {
    const res = await apiClient.put(`/api/l202/${encodeURIComponent(docCode)}/${seqNo}`, data);
    return res.data;
  },

  async delete(docCode: string, seqNo: number): Promise<void> {
    await apiClient.delete(`/api/l202/${encodeURIComponent(docCode)}/${seqNo}`);
  },
};
